import React, { ReactNode } from 'react';

interface ScrollElementProps {
    children: ReactNode,
    height: string,
    className?: string
}

const ScrollElement: React.FC<ScrollElementProps> = (props) => {
    const style = {
        height: props.height
    }

    return (
        <div
            className='scroll-element' 
            style={style}>
            {props.children}
        </div>
    );
};

export default ScrollElement;